import Slider from './components/Slider';
import functions from './functions';
import inputPopover from "./components/input-popover.js";
import { FormGuide } from "./components/form-guide.js";
import { InputGuests } from "./components/input-guests";
import { DeparturePicker } from "./components/departure-picker.js";
import { Select2 } from "./components/select2";

$(() => {

  const $mainHeader = $('.main-header');

  if(functions.isMobile()) {
    $('#offcanvasNavbar').on('show.bs.offcanvas', e => {
      //$mainHeader.css('z-index', 1060);
      $mainHeader.css('z-index', 10004);
    });
  
    $('#offcanvasNavbar').on('hidden.bs.offcanvas', e => {
      $mainHeader.css('z-index', 100);
    });
  }

  $('.btn-level').on('click', e => {
    e.preventDefault();
    e.stopPropagation();
    // const $target = $(e.currentTarget);
    // const $sibling = $target.siblings('.dropdown-submenu');

    // $target.toggleClass('show', ! $sibling.hasClass('show'));
    // $sibling.toggleClass('show', ! $sibling.hasClass('show'));
  });

  /*if ($(window).scrollTop() > 100) {
    $('.main-header').addClass('following');
  }*/

  /*$(window).scroll(e => {

    $(window).scrollTop() > 10
      ? $('.main-header').addClass('following')
      : $('.main-header').removeClass('following');
  });*/

  $('#navMainMenu').on('show.bs.collapse', e => {
    $('.navbar').addClass('show');
  });
  $('#navMainMenu').on('hide.bs.collapse', e => {
    $('.navbar').removeClass('show');
  });

  const $heroSlider = $('#hero-slider');

  if ( $heroSlider.length ) {    
      $heroSlider._slider = new Slider($heroSlider, {
        fade: false,
        rubberband: false,
        loop: true,
        arrows: true,
        pager: true,
        //autoplay: 4000,
        slides: {
          perView: 1,
          spacing: 0
        },
        defaultAnimation: {
            duration: 0
        },
        detailsChanged: (s) => {
          s.slides.forEach((element, idx) => {
            if ( s.track.details.slides[idx].portion == 0 ) {
              element.style.opacity = 0;
            }
            if ( s.track.details.slides[idx].portion == 1 ) {
              element.style.opacity = 1;
            }
          })
        },
        //renderMode: "custom",
      });
      $heroSlider.find('.keen-slider__slide').first().addClass('active');
  }

  const isMobile = functions.isMobile();

  let listSlider = [];
  $('[id^=list-slider]').each((i, elem) => {
      const length = $(elem).find('.keen-slider__slide').length;

      listSlider[i] = new Slider('#' + $(elem).attr('id'), {
          rubberband: false,
          loop: true,
          arrows: true,
          spacing: 0,
          pager: true,
          drag: isMobile,
          slides: {
            perView: 2,
            spacing: 0
        },
        breakpoints: {
          '(max-width: 1920px)': {
              origin: 'center',
              drag: true,
              loop: true,
              slides: {
                  perView: 3,
                  spacing: 0,
              },
          },
          '(max-width: 1360px)': {
              origin: 'center',
              drag: true,
              loop: true,
              slides: {
                  perView: 2,
                  spacing: 0,
              },
          },
          '(max-width: 991px)': {
              origin: 'center',
              drag: true,
              loop: true,
              slides: {
                  perView: 2.2,
                  spacing: 0,
              },
          },
          '(max-width: 767px)': {
              origin: 'center',
              drag: true,
              loop: true,
              slides: {
                  perView: 1.1,
                  spacing: 0,
              },
          },
      },
      });

      const $arrows = $(elem).siblings('.keen-slider__arrows');

      if (isMobile && length < 2) {
        $arrows.addClass('d-none');
      } else if (! isMobile && length < 3) {
        $arrows.addClass('d-none');
      } else {
        $arrows.removeClass('d-none');
      }

  });

  let pageSlider = [];
  $('[id^=page-slider]').each((i, elem) => {

    let pageSliderPerView = $(elem).attr('data-perView') || 3;

    if (pageSliderPerView < 3) {
      $(elem).append('<div class="wp-block-custom-gutenberg-page-slide keen-slider__slide page-slide fake-slide"></div>');
      $(elem).append('<div class="wp-block-custom-gutenberg-page-slide keen-slider__slide page-slide fake-slide"></div>');
    }

    const $items = $(elem).find('.keen-slider__slide');

    pageSlider[i] = new Slider('#' + $(elem).attr('id'), {
        //items: $items,
        // selector: '.keen-slider__slide.card-slide',
        loop: false,
        drag: $items.length > 3 ? true : false,
        arrows: true,
        pager: true,
        slides: {
            perView: pageSliderPerView,
            spacing: 0
        },
        breakpoints: {
          '(max-width: 1920px)': {
            origin: 'center',
            drag: true,
            loop: true,
            slides: {
                perView: pageSliderPerView,
                spacing: 0,
            },
        },
        '(max-width: 1360px)': {
            origin: 'center',
            drag: true,
            loop: true,
            slides: {
                perView: pageSliderPerView - 1,
                spacing: 0,
            },
        },
        '(max-width: 991px)': {
            origin: 'center',
            drag: true,
            loop: true,
            slides: {
                perView: 2.2,
                spacing: 0,
            },
        },
        '(max-width: 767px)': {
            origin: 'center',
            drag: true,
            loop: true,
            slides: {
                perView: 1.1,
                spacing: 0,
            },
        },
      },
    });

    $items.first().hasClass('active') && $items.last().addClass('hide');

    //$items.first().addClass('active');

    //let activeIndex = pageSlider[i].instance.track.details.rel || 0;
    //const $arrows = $(elem).siblings('.keen-slider__arrows');
    //activeIndex == 0 && $arrows.find('[data-dir="prev"]').addClass('disabled');

    // const $arrows = $(elem).siblings('.keen-slider__arrows');

    // if (isMobile && length < 2) {
    //   $arrows.addClass('d-none');
    // } else if (! isMobile && length < 3) {
    //   $arrows.addClass('d-none');
    // } else {
    //   $arrows.removeClass('d-none');
    // }

  });

  let navTabSlider = [];
  $('[id^=nav-tab].keen-slider').each((i, elem) => {
    navTabSlider[i] = new Slider('#' + $(elem).attr('id'), {
      rubberband: false,
      loop: false,
      drag: true,
      arrows: true,
      //pager: true,
      slides: {
          perView: 'auto',
          spacing: 1
      },
      breakpoints: {
        '(max-width: 767px)': {
          slides: {
            perView: 1.5,
          },
        },
      }
    });
  });

  //let formGuide = [];
  $('.form-guide').each((i, elem) =>{
      elem._formGuide = new FormGuide(elem);
      //formGuide[i + 1] = new FormGuide(elem);
  });

  $('.datepicker.departure-picker:not(#details-datepicker) [data-input]').each((i, elem) => {
    elem._departurePicker = new DeparturePicker(elem);
  });

  $('.input-guests').each((i, elem) => {
    elem._inputGuests = new InputGuests(elem);
  });

  inputPopover.apply();

  $(".select2").each((i, elem) => {
    elem._select2 = new Select2(elem);
  });

  $('[name=dates], [name=dateFrom]').on('change', e => {
    const $target = $(e.currentTarget);
    
    let $datepicker = $target.parents('.datepicker-range');

    if($target.parents('.departure-picker').length) {
      $datepicker = $target.parents('.departure-picker');
    } else if ($target.parents('.datepicker-range-inquiry').length) {
      $datepicker = $target.parents('.datepicker-range-inquiry');
    }

    $datepicker.length && $datepicker.find('[data-clear]').toggleClass('d-none', ! $target.val());
  });

  $('.show-more').each( (i, elem) => {
        let $showMore = $(elem);

        if ($showMore.find('.show-more-content').outerHeight() < 150)
        {
            $showMore.addClass('removeBefore');
            $showMore.next('.show-more-expand').remove();
            return;
        }
        let height = $showMore.attr('data-height');
        let $breakpoint = $showMore.find('.show-more-breakpoint');
        if (height)
        {
            $showMore.css('max-height', +height);
        }
        else if ($breakpoint.length) 
        {
            $showMore.css('max-height', $breakpoint.offset().top - $showMore.offset().top - 25);
        }
        else 
        {
            let $maxHeight = functions.isMobile() ? 
                        ($showMore.outerHeight() * 0.15) : 
                        ($showMore.outerHeight() * 0.3);

            $showMore.css('max-height', $maxHeight);
        }
    
        $showMore.next('.show-more-expand').on('click', e => {
            let $prevSibling = $(e.currentTarget).prev();
            let $maxHeight
            if ($prevSibling.hasClass('removeBefore'))
            {
                let height = $prevSibling.attr('data-height');
                let $breakpoint = $prevSibling.find('.show-more-breakpoint');
                if (height)
                {
                    $maxHeight = +height;
                }
                else if ($breakpoint.length) 
                {
                    $maxHeight = $breakpoint.offset().top - $showMore.offset().top - 25;
                }
                else 
                {
                    $maxHeight = functions.isMobile() ? 
                        ($prevSibling.outerHeight() * 0.15) : 
                        ($prevSibling.outerHeight() * 0.3);
                }
                $prevSibling.css('max-height', $maxHeight);
                $prevSibling.removeClass('removeBefore');
                if ($prevSibling.hasClass('show-more-scroll')) 
                {
                    $('html, body').stop().animate({
                        scrollTop: $prevSibling.offset().top + $maxHeight - $(e.target).outerHeight(),
                    }, 0, 'linear');
                }
            }
            else 
            {
                let $content = $prevSibling.find('.show-more-content');
                $prevSibling.css('max-height', $content.outerHeight());
                $prevSibling.addClass('removeBefore');
            }
        })
    });

});